import { AsyncAjaxPost } from "components/Common/AsyncAjaxService";
import Loader from "components/Common/Loader";
import { useEffect, useState } from "react";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { AsyncAjaxGet } from "vagaro-website-rendering/src/components/Utilities/AsyncAjaxService";
import { ValidateToken } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { StyleSet } from "./SetLibraryMenu";
import { CreateSiteStylingFromSetData, setStyleDenotation } from "./SetUtils";
import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";
import ReactDOM from "react-dom";
import PreviewScreen from "components/WebDesigner/PreviewScreen";
import { DefaultSiteData } from "components/WebDesigner/Data/SiteData";
import { useSelector } from "react-redux";
import { utils } from "vagaro-website-rendering/src/utils/Utils";

  const VagaroAPIEnum = {

    Getlayoutlist: "layout/layoutlist",
    LayoutChange:  "/websitebuilders/changeslayout",
    LayoutPreview:"LayoutPageFile/layoutpreview?LayoutId=",
    StartFromScratch:"/websitebuilders/startfromstratch",
};

async function GetLayoutList(mid:number,userContext:UserContext,onComplete: (response: any) => void,OnFail: (error: any) => void,pageIndex:number = 1,pageSize:number = 30) {

    let rootURL = VagaroAPIEnum.Getlayoutlist;
    

    await ValidateToken(userContext);

    const body = {
        LoginUserId: userContext.userId,
        MerchantId: mid,
        PageIndex:pageIndex,
        PageSize:pageSize,

    }

    await AsyncAjaxPost(
        rootURL,
        body,
        userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (OnFail) {
                OnFail(data);
            }
        }
    )
}

// async function ChangeLayout(userContext:UserContext,layoutID:string,onComplete: (response: any) => void,OnFail: (error: any) => void) {
    
//         let rootURL =  userContext.businessId+ VagaroAPIEnum.LayoutChange+"?layoutId="+layoutID;
    
    
//         await ValidateToken(userContext);
    
 
    
//         await AsyncAjaxPut(
//             rootURL,

//             userContext.accessToken,
//             null,
//             function onSuccess(data: any) {
//                 if (onComplete) {
//                     onComplete(data);
//                 }
//             },
//             function OnError(data: any) {
//                 if (OnFail) {
//                     OnFail(data);
//                 }
//             }
//         )
    

// }

export async function SetStartFromScratch(userContext:UserContext,postBody:string,onComplete?: (response: any) => void,OnFail?: (error: any) => void){

    await ValidateToken(userContext);

    let rootURL = userContext.businessId+VagaroAPIEnum.StartFromScratch;

    await AsyncAjaxPost(rootURL,postBody,userContext.accessToken,(data:any) => {
        if(onComplete){
            onComplete(data);
        }
    },(error:any) => {
        if(OnFail){
            OnFail(error);
        }
    }
    );
    
}

async function GetLayoutPreview(userContext:UserContext,layoutID:string,onComplete: (response: any) => void,OnFail: (error: any) => void) {
    await ValidateToken(userContext);
    let rootURL = VagaroAPIEnum.LayoutPreview+layoutID;
    await AsyncAjaxGet(
        rootURL,
        userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (OnFail) {
                OnFail(data);
            }
        }
    )

}


type LayoutData = {
    id :  string ,
    layoutTitle :  string,
    layoutDescription :  string ,
    layoutImage : string ,
    isActive : boolean,
    isSoftDelete : boolean,
    overallCount : number,
    rank :number,
    businessLayoutID :  string ,
    businessLayoutIDs :  string 
}

export default function SetLayoutList({userContext,colorSet,imageSet,fontSet}: {userContext:UserContext,colorSet:StyleSet,imageSet:StyleSet,fontSet:StyleSet}) {
    
    const [layoutList, setLayoutList] = useState<LayoutData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [windowLoading,setWindowLoading] = useState<boolean>(false);

    const {ReactBusinessId,ReactUserID } = useSelector((state: any) => state.Business);

    useEffect(() => {

        userContext.userId = ReactUserID;
        GetLayoutList(ReactBusinessId,userContext,(response) => {
       
            let list = response?.data?.data??[];
            list = list.filter((layout:LayoutData) => layout.isActive && !layout.isSoftDelete); 
            setLayoutList(list);
            setIsLoading(false);
        },(error) => {
            console.log(error);
            setIsLoading(false);
        })


//eslint-disable-next-line
    }, [])
    
    if(isLoading){
        return<div className="loader-imgNew"></div>
    }
    
    let fciURL = "unset";

    if(colorSet && imageSet && fontSet){
        fciURL = setStyleDenotation+`${fontSet.id}-${colorSet.id}-${imageSet.id}`;
    }

    const onSelect = (layoutData:LayoutData) =>{


        setWindowLoading(true);

        let style = CreateSiteStylingFromSetData(fontSet.items,colorSet.items,imageSet.items);
        const siteString = {
            styling: style,
            imageUrls: style.imageMapping,
            lastPublishDate:"",
            homePageId: ""
        }

        let postData = {
            Content: JSON.stringify(siteString),
            Created_By: userContext.userId,
            layoutId: layoutData.id,

        }
        const content = JSON.stringify(postData);


        SetStartFromScratch(userContext,content,(data:any) => {
            let link = document.createElement("a");

            let result = data?.data?.data;

            if(!result){
                AlertConfirm("Error starting from scratch");
                setWindowLoading(false);
                return;
            }

            if(!result.layoutId || !result.styleId){
                AlertConfirm("Error starting from scratch, existing layout or style found.");
                setWindowLoading(false);
                return;
            }
          
            let lnk = `/business/${result.styleId}/${result.layoutId}/designer`;

            if(window.location.href.includes("ProApp")||utils.IsFromProApp())
            lnk+="?isProApp=true";

            link.href = lnk;
            

            document.body.appendChild(link);
            link.click();

         },(error) => {

            AlertConfirm("Error starting from scratch");
            setWindowLoading(false);

         });
        // ChangeLayout(userContext,layoutData.id,(data:any) => {
        // let link = document.createElement("a");
        // link.href = `/admin/${fciURL}/${layoutData.id}/designer`;
        // document.body.appendChild(link);
        // link.click();
        // },(error) => {

        //     AlertConfirm("Error changing layout");
        //     setWindowLoading(false);

        // });
    }

    const onPreview =  (layoutData:LayoutData) =>{
        setWindowLoading(true);
   
         GetLayoutPreview(userContext,layoutData.id,(data:any) => {
            setWindowLoading(false);










            const dom =  document.getElementById("OpenDialog2");
            
            const PopupClose = ()=>{
        
                if(dom){
                    ReactDOM.unmountComponentAtNode(dom);
                }
            }
        
            if(!data?.data?.data){
                AlertConfirm("Error loading preview");
          
                return;
            }
            let content = data.data.data;
        
            try{
            let node = JSON.parse(content);

        
            let siteData = {...DefaultSiteData};
            siteData.siteStyling = CreateSiteStylingFromSetData(fontSet.items,colorSet.items,imageSet.items);
            userContext.imageMapping = imageSet.items;
            siteData.userContext = userContext;
            
        
            
            ReactDOM.render(
                <>
                <div className="" style={{position:"fixed",zIndex:"1000",top:"0",left:"0",width:"100%",height:"100%",background:"rgba(0,0,0,.5)"}} onClick={PopupClose}></div>
                <PreviewScreen siteData={siteData} root={node} edgeSize={32} showFooter={true} onSelect={()=>onSelect(layoutData)} onDismiss={PopupClose} /></>
               ,
                dom);
            }
            catch{
                AlertConfirm("Error parsing preview");
              
            }



        },(error) => {
            AlertConfirm("Error loading preview");
            setWindowLoading(false);
        });
    }


    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/") : ("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");
    return <>
      
    <div className="flex-row flex-wrap w-full">

        {windowLoading && <Loader/>}
        {layoutList.map((layoutData,index) => {
           
  

            return <LayoutListItem fciURL={fciURL} key={index} cdn={cardImgPath} layoutData={layoutData} fadeDelay={`${index*0.1}s`} onSelect={onSelect} onPreview={onPreview}/>
        })}

    </div></>
}




function LayoutListItem({layoutData,fadeDelay,cdn,fciURL,onSelect,onPreview}: {layoutData:LayoutData,fadeDelay:string,cdn:string,fciURL:string,onSelect:(data:LayoutData)=>void,onPreview:(data:LayoutData)=>void}) {

   return <div className=" layout-card vanimation-fade-in-up" style={{animationDelay:fadeDelay}}
   

   >
        <div className="layout-card-overlay">
            <button className="w-button w-button-primary" onClick={() => onSelect(layoutData)}>Use This Layout</button>
            <button className="w-button w-button-ghost" onClick={() => onPreview(layoutData)}>Preview</button>
        </div>
        <img src = {"https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/styale-thum-empty.gif"}
        alt = {layoutData.layoutTitle}
        style={{backgroundImage:`url(${cdn+layoutData.layoutImage})`}}
        >
    </img>
    <div className="layout-card-content">
        <h3>{layoutData.layoutTitle}</h3>
        <p>{layoutData.layoutDescription}</p>
    </div>
    </div>

}

